import { LayoutOrientedConfigService } from '@alfresco/adf-content-services';

export class WkLayoutOrientedConfigService extends LayoutOrientedConfigService {
  constructor(private readonly wkConfig: any) {
    super(wkConfig);
  }

  public reorganiseByConfig(propertyGroups: any): any {
    return this.wkConfig.map((layoutBlock) => {
      const flattenedItems = this.wkFlattenItems(layoutBlock.items),
        properties = flattenedItems.reduce((props, explodedItem) => {
          const property =
            this.getProperty(
              propertyGroups,
              explodedItem.groupName,
              explodedItem.propertyName
            ) || [];
          return props.concat(property);
        }, []);

      return {
        title: layoutBlock.title,
        properties,
      };
    });
  }

  private wkFlattenItems(items) {
    return items.reduce((accumulator, item) => {
      const properties = Array.isArray(item.properties)
        ? item.properties
        : [item.properties];
      const flattenedProperties = properties.map((propertyName) => {
        return {
          groupName: item.aspect || item.type,
          propertyName,
        };
      });

      return accumulator.concat(flattenedProperties);
    }, []);
  }

  private getProperty(
    propertyGroups: any,
    groupName: string,
    propertyDef: any
  ): any {
    const groupDefinition = propertyGroups[groupName] || { properties: {} };
    const groupDefinitionProperties = groupDefinition.properties;

    let propertyDefinitions;

    if (propertyDef === '*') {
      propertyDefinitions = Object.keys(groupDefinitionProperties).map(
        (key) => groupDefinitionProperties[key]
      );
    } else if (typeof propertyDef === 'string') {
      propertyDefinitions = groupDefinitionProperties[propertyDef];
    } else if (
      typeof propertyDef === 'object' &&
      groupDefinitionProperties[propertyDef.name]
    ) {
      propertyDefinitions = Object.assign(
        groupDefinitionProperties[propertyDef.name],
        propertyDef
      );
    }

    return propertyDefinitions;
  }
}
